module.exports = __webpack_public_path__ + "static/api_bg@3x-a0e7c629da45c13e48698d6c37accf58.png";